import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, provideDefaultConfig, UrlModule } from '@spartacus/core';
import { CarouselModule, CarouselService, MediaModule } from '@spartacus/storefront';
import { UigProductCarouselComponent } from './uig-product-carousel.component';
import { RouterModule } from '@angular/router';
import { UigCarouselService } from 'src/app/services/uig-carousel.service';

@NgModule({
  declarations: [UigProductCarouselComponent],
  imports: [CommonModule,CarouselModule, MediaModule, RouterModule, UrlModule ],
  providers: [
    {
      provide: CarouselService,
      useClass: UigCarouselService
    },
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        ProductCarouselComponent: {
          component: UigProductCarouselComponent,
        },
      },
      backend: {
        occ: {
          endpoints: {
            product: {
              list: 'products/${productCode}?fields=code,name,summary,price(formattedValue),images(DEFAULT,galleryIndex),baseProduct,uspInfo',
            },
          },
        },
      },
   }),
  ],
  exports: [UigProductCarouselComponent],

})
export class UigProductCarouselModule { }
